"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setCookie = void 0;
const constants_1 = require("./constants");
const thirtyDays = 2592000;
const defaultOptions = {
    domain: window.location.hostname,
    'max-age': thirtyDays,
    secure: true,
};
const setToCookieString = (key, value) => {
    return `; ${key}=${value}`;
};
const setCookie = (name, value, options = defaultOptions) => {
    let updatedCookie = `${encodeURIComponent(constants_1.COOKIE_APP_PREFIX + name)}=${encodeURIComponent(value)}`;
    if (typeof options.domain === 'string') {
        updatedCookie += setToCookieString('domain', options.domain);
    }
    if (typeof options['max-age'] === 'number') {
        updatedCookie += setToCookieString('max-age', options['max-age']);
    }
    if (options.secure) {
        updatedCookie += '; secure';
    }
    document.cookie = updatedCookie;
};
exports.setCookie = setCookie;
